import { render } from "./raw_material_stock.vue?vue&type=template&id=4522b9cd"
import script from "./raw_material_stock.vue?vue&type=script&lang=js"
export * from "./raw_material_stock.vue?vue&type=script&lang=js"

import "./raw_material_stock.vue?vue&type=style&index=0&id=4522b9cd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__